import { ConnectorStatus, StationStatus } from "../enums/connectorStatus";

export interface StationStatusMessage {
  stationStatus: StationStatus;
}

export interface ConnectorStatusMessage {
  connectorId: number;
  status: ConnectorStatus;
}

export interface HeartbeatMessage {
  message: [number, string, string, object];
}

/**
 * Sent by the gateway when the charger answers RemoteStartTransaction with
 * anything but Accepted — typically because a transaction is still running on
 * that connector. The PREPARE session has already been closed server-side.
 */
export interface RemoteStartRejectedMessage {
  remoteStartRejected: {
    connectorId: number;
    sessionId: number | null;
    status: string;
  };
}

export function isRemoteStartRejectedMessage(
  msg: unknown,
): msg is RemoteStartRejectedMessage {
  return (
    msg !== null &&
    typeof msg === 'object' &&
    'remoteStartRejected' in msg &&
    typeof (msg as RemoteStartRejectedMessage).remoteStartRejected === 'object'
  );
}
